/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    readonly id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Payment
     */
    paymentDate: Date;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    amountPaidToClient: number;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    totalAmountReceived: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    status: PaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    percentagePayable: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    readonly fromSociety?: string;
    /**
     * 
     * @type {Date}
     * @memberof Payment
     */
    dateCreated: Date;
}


/**
 * @export
 */
export const PaymentStatusEnum = {
    Held: 'held',
    ToBeTransferred: 'to_be_transferred',
    WaitingChequeClear: 'waiting_cheque_clear',
    Cleared: 'cleared'
} as const;
export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];


/**
 * Check if a given object implements the Payment interface.
 */
export function instanceOfPayment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "percentagePayable" in value;
    isInstance = isInstance && "dateCreated" in value;

    return isInstance;
}

export function PaymentFromJSON(json: any): Payment {
    return PaymentFromJSONTyped(json, false);
}

export function PaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Payment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'paymentDate': (new Date(json['payment_date'])),
        'amountPaidToClient': json['amount_paid_to_client'],
        'totalAmountReceived': json['total_amount_received'],
        'status': json['status'],
        'percentagePayable': json['percentage_payable'],
        'fromSociety': !exists(json, 'from_society') ? undefined : json['from_society'],
        'dateCreated': (new Date(json['date_created'])),
    };
}

export function PaymentToJSON(value?: Payment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payment_date': (value.paymentDate.toISOString()),
        'amount_paid_to_client': value.amountPaidToClient,
        'total_amount_received': value.totalAmountReceived,
        'status': value.status,
        'percentage_payable': value.percentagePayable,
        'date_created': (value.dateCreated.toISOString()),
    };
}

